import {
  Button,
  Center,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Progress,
  Text,
  Tooltip,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import { useState } from 'react'
import Axios from 'axios'
import { user } from '../../../../../helpers/user'
import { InputDragAndDrop } from '../InputDragAndDrop'
import { ModalSlideImages } from '../ModalSlideImages'
import { useMutation, useQueryClient } from 'react-query'

export function ModalProduct({ selectedField, item }) {
  const [open, setOpen] = useState(false)
  const [images, setImages] = useState([])
  const [progress, setProgress] = useState(0)

  const queryClient = useQueryClient()

  const { mutate, isLoading } = useMutation(async () => {
    const formData = new FormData()

    formData.append('codigo_usuario', codUsu)

    formData.append('codigo_produto', item?.diretorio)

    images.forEach((image, index) => {
      formData.append(`imagem[]`, image)
    })

    const urlComplete = label === 'Innovation Store' ? '-store' : ''

    const url = `${process.env.REACT_APP_BASE_URL}/site/v2/fluxo-imagem/upload-imagens-produtos-s3${urlComplete}`

    const response = await Axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent

        let percent = Math.floor((loaded * 100) / total)

        setProgress(percent)
      },
    })

    toast({
      title: 'Imagens enviadas com sucesso',
      description: 'As imagens foram enviadas com sucesso',
      status: 'success',
      duration: 9000,
      isClosable: true,
      position: 'top-right',
    })

    setImages([])
    setProgress(0)
    onClose()

    queryClient.invalidateQueries('images-upload-production')
  })

  const codUsu = user?.codigo_usuario

  const toast = useToast()

  const label = selectedField === 'innovationBrindes' ? 'Innovation Brindes' : 'Innovation Store'

  const { isOpen, onOpen, onClose } = useDisclosure({
    onOpen: () => {
      setOpen(true)
    },
    onClose: () => {
      setOpen(false)
      setImages([])
    },
  })

  const image =
    label === 'Innovation Brindes'
      ? 'https://imgproductioncrm.s3.us-east-2.amazonaws.com/pastanova.png'
      : 'https://imgproductioncrm.s3.us-east-2.amazonaws.com/pastanova-preta.png'

  const caracteristicas = item?.caracteristicas?.length > 30 ? item?.caracteristicas.substring(0, 30) + '...' : item?.caracteristicas

  const imagePasteOpen = label === 'Innovation Brindes' ? 'pasta-aberta-blue' : 'pasta-aberta-black'

  // async function uploadImage() {
  //   setLoadingUpload(true)
  //   try {
  //     const formData = new FormData()

  //     formData.append('codigo_usuario', codUsu)

  //     formData.append('codigo_produto', item?.diretorio)

  //     images.forEach((image, index) => {
  //       formData.append(`imagem[]`, image)
  //     })

  //     console.log('images', images)

  //     const urlComplete = label === 'Innovation Store' ? '-store' : ''

  //     const url = `${process.env.REACT_APP_BASE_URL}/site/v2/fluxo-imagem/upload-imagens-produtos-s3${urlComplete}`

  //     const response = await Axios.post(url, formData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //       onUploadProgress: (progressEvent) => {
  //         const { loaded, total } = progressEvent

  //         let percent = Math.floor((loaded * 100) / total)

  //         setProgress(percent)
  //       },
  //     })

  //     toast({
  //       title: 'Imagens enviadas com sucesso',
  //       description: 'As imagens foram enviadas com sucesso',
  //       status: 'success',
  //       duration: 9000,
  //       isClosable: true,
  //       psotion: 'top-right',
  //     })

  //     console.log(response)

  //     setImages([])

  //     onClose()
  //   } catch (error) {
  //     console.log(error)
  //     toast({
  //       title: 'Erro ao fazer upload das imagens',
  //       description: 'Tente novamente mais tarde',
  //       status: 'error',
  //       duration: 9000,
  //       isClosable: true,
  //       psotion: 'top-right',
  //     })
  //   }

  //   setLoadingUpload(false)
  //   setImages([])
  // }

  return (
    <>
      <Flex direction="column" align="center" justify="center" gap={2} onClick={onOpen}>
        {!open ? (
          <Image
            src={image}
            alt="pasta"
            w="80px"
            cursor="pointer"
            transition="all 0.1s"
            _hover={{
              transform: 'scale(1.1)',
            }}
          />
        ) : (
          <Image src={`https://imgproductioncrm.s3.us-east-2.amazonaws.com/${imagePasteOpen}.png`} alt="pasta" w="80px" />
        )}
        {item.diretorio}
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Nova pasta de Imagens - {label}</ModalHeader>
          <ModalCloseButton />
          <ModalBody display="flex" flexDir="column" w="100%" gap={4}>
            <Flex flexDir="column">
              <Flex
                justifyContent="flex-start"
                w="100%"
                boxShadow="0 0 0 1px rgba(0,0,0,0.1)"
                borderRadius="md"
                p="1rem"
                mb="1rem"
                bg="gray.50"
                gap={5}
              >
                <Flex w="200px">
                  <Image
                    src={item?.imagens?.length > 0 ? item?.imagens[0].url : 'https://imgproductioncrm.s3.us-east-2.amazonaws.com/pastanova.png'}
                    _loading={{
                      src: '/images/loading-blue.gif',
                    }}
                    fallbackSrc="/images/loading-blue.gif"
                    alt="pasta"
                    cursor="pointer"
                    transition="all 0.1s"
                    _hover={{
                      transform: 'scale(1.1)',
                    }}
                  />
                </Flex>
                <Flex flexDir="column">
                  <Text>
                    Produto:{' '}
                    <Text as="span" color="blue.800" fontWeight="bold">
                      {item?.descricao}
                    </Text>
                  </Text>
                  <Tooltip label={item?.caracteristicas} aria-label="A tooltip">
                    <Text>
                      Características:{' '}
                      <Text as="span" color="blue.800" fontWeight="bold">
                        {caracteristicas}
                      </Text>
                    </Text>
                  </Tooltip>

                  <Text>
                    Dimensões:{' '}
                    <Text as="span" color="blue.800" fontWeight="bold">
                      {item?.dimensao}
                    </Text>
                  </Text>
                  <Text>
                    Quantidade de imagens:{' '}
                    <Text as="span" color="blue.800" fontWeight="bold">
                      {item?.qtd_imagens}
                    </Text>
                  </Text>
                </Flex>
              </Flex>
              <Flex
                justifyContent="flex-start"
                w="100%"
                boxShadow="0 0 0 1px rgba(0,0,0,0.1)"
                borderRadius="md"
                p="1rem"
                mb="1rem"
                bg="gray.50"
                flexWrap="wrap"
                gap={2}
              >
                <ModalSlideImages images={item?.imagens} />
              </Flex>
              <Center mb="1rem">Cadastrar mais imagens</Center>
              {progress > 0 && <Progress hasStripe value={progress} mb="1rem" />}
              <InputDragAndDrop images={images} setImages={setImages} />
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" ml="auto" disabled={images.length === 0} isLoading={isLoading} loadingText="Enviando" onClick={mutate}>
              Enviar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
